"use client";
import React from "react";
import Image from "next/image";
import { AspectRatio, Center, Heading, HStack } from "@chakra-ui/react";
import { HEADING_VARIANTS } from "@/theme/components/heading";
import PocCloudWhite from "public/cloud-services/poc-cloud-white.svg";
import PocCloud from "public/cloud-services/poc-cloud.svg";
import PrivateCloudWhite from "public/cloud-services/private-cloud-white.svg";
import PrivateCloud from "public/cloud-services/private-cloud.svg";
import PocCloudCards from "./pocCloud";
import PrivateCloudCards from "./privateCloud";
import { SERVICES_TABS } from "./constants";

export const tablist = [
  {
    component: PrivateCloudCards,
    label: ({ isSelected }) => (
      <Center>
        <HStack spacing={2}>
          <AspectRatio ratio={1} w={"24px"} position={"relative"}>
            <Image
              alt="private cloud"
              src={isSelected ? PrivateCloudWhite : PrivateCloud}
              fill
              style={{ objectFit: "contain", objectPosition: "center" }}
            />
          </AspectRatio>
          <Heading fontWeight={600} variant={HEADING_VARIANTS.SUBTITLE3}>
            {SERVICES_TABS.PRIVATE_CLOUD}
          </Heading>
        </HStack>
      </Center>
    ),
  },
  {
    component: PocCloudCards,
    label: ({ isSelected }) => (
      <Center>
        <HStack spacing={2}>
          <AspectRatio ratio={1} position={"relative"} w={"24px"}>
            <Image
              alt="poc cloud"
              src={isSelected ? PocCloudWhite : PocCloud}
              fill
              style={{ objectFit: "contain", objectPosition: "center" }}
            />
          </AspectRatio>
          <Heading fontWeight={600} variant={HEADING_VARIANTS.SUBTITLE3}>
            {SERVICES_TABS.POC_CLOUD}
          </Heading>
        </HStack>
      </Center>
    ),
  },
];
